export default {
  title: 'Опа! Страницата не беше намерена!',
  subtitle: 'Стигнахте до ръба на видимата вселена на Sportya.',
  goHome: 'Към вкъщи',
  contact: `
    <0>И ни кажи как стигнахте тук, за да можем да изградим по-добър свят (и по-добър уебсайт) - <1>contact@sportya.net</1>.\nБлагодаря, приятелю!`,
};
